export function toFixedNumber(
  value: string | number,
  decimalPlaces: number = 2
): number {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return parseFloat(num.toFixed(decimalPlaces));
}
